import React from 'react';

// GLOBAL VARIABLES
import { ACCOUNTING_TASKS, INTERFACE } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions.js';

// ROUTER COMPONENTS
import { Navigate, Route, Routes } from "react-router-dom";

// ROUTES
import Backend from './accountingTasks/Backend';
import DealCount from './accountingTasks/DealCount';
import Frontend from './accountingTasks/Frontend';

// MAIN COMPONENT
const AccountingTasks = () => (
  <Routes>
    <Route
      path={makePath(ACCOUNTING_TASKS.dealCount)}
      element={<DealCount />}
    />
    <Route
      path={makePath(ACCOUNTING_TASKS.frontend)}
      element={<Frontend />}
    />
    <Route
      path={makePath(ACCOUNTING_TASKS.backend)}
      element={<Backend />}
    />
    <Route path="*" element={<Navigate to={makePath(INTERFACE.accountingTasks, ACCOUNTING_TASKS.dealCount)} replace />} />
  </Routes>
)

// EXPORT
export default AccountingTasks;
